import { NONE_TYPE } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ValidateformComponent } from 'src/app/common/validateform/validateform.component';
import { AlertService } from 'src/app/services/AlertService';
import { ResourceService } from 'src/app/services/ResourceService';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-resource-center-view',
  templateUrl: './resource-center-view.component.html',
  styleUrls: ['./resource-center-view.component.scss'],
  providers: [ConfirmationService]
})
export class ResourceCenterViewComponent implements OnInit {

  categories:any[];
  resourcecategories: TreeNode[]= [];
  msgs: any;
  searchterm: string;

  parentCategories: any[] = [];
  selectedParentCategory: any;
  
  Name: string
  Description: string;
  addcatDialog: boolean;
  submitted: boolean;
  @ViewChild('f', { static: true }) addCatForm: NgForm;
  @ViewChild(ValidateformComponent, { static: true })
    private formValidator: ValidateformComponent;
    canAddResource: boolean = false;
    canViewEditResourceCategory: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private breadcrumbService: AppBreadcrumbService, private router: Router, 
      private resourceservice: ResourceService, private confirmationService: ConfirmationService,
      private alertService: AlertService, private accountService: AccountService) {
    this.breadcrumbService.setItems([
        { label: 'Resource-Center', routerLink: ['resource-center/view'] }
    ]);
}
  ngOnInit(): void {     
    this.categories = this.activatedRoute.snapshot.data['resourcecategories'];
      this.categoriesToTreeNodes(this.categories);
      this.canAddResource = this.accountService.CanAddResource();
      this.canViewEditResourceCategory = this.accountService.CanViewEditResourceCategory();
  }

  SearchResources($event)
  {
     this.router.navigate(['/resource-list/search/'+ this.searchterm]);
  }

  openNew() {
    this.Name= "";
    this.Description = ""
    this.selectedParentCategory = null;
    this.submitted = false;
    this.addcatDialog = true;
  }
  hideDialog() {
    this.addcatDialog = false;
    this.submitted = false;
  }
  
  showParentCatMsg():boolean{
    return this.selectedParentCategory !=null &&  this.selectedParentCategory.Id == 0? false: true;
  
  }

  AddResourceCategory():boolean
  {     
    
    
    if(this.formValidator.validateForm())
     {
        let cat: any = {};
        cat.Name = this.Name;
        cat.Description = this.Description;
        cat.ParentCategoryId = this.selectedParentCategory ? this.selectedParentCategory.Id : 0; 
        
        this.resourceservice.AddResourceCategory(cat).subscribe
        (res => {              
          this.categories = res;   
          this.categoriesToTreeNodes(this.categories);
        })
        ,
        error => {
            this.alertService.SetMessage('error', 'There is an error while adding category');
        };    
        
        this.Name= "";
        this.Description = ""
        this.selectedParentCategory = null;
        this.hideDialog();
        return true; 
      }
     
  }

  DeleteCategory(cat: any)
  {
   
      this.confirmationService.confirm({
        key: "DeleteResourceCategoryConfirmDialog",
        message: 'Deleting Resource Category will delete all the subcategories and the resources under them. Are you sure you want to delete this Resource Category?',
        accept: () => {
  
          this.resourceservice.InactivateResourceCategory(cat.data).subscribe
          (res => {        
            this.categories = res;   
            this.categoriesToTreeNodes(this.categories);
          })
          ,
          error => {
              this.alertService.SetMessage('error', 'There is an error while deleting category');
          };    
          
        }
      });      
  }

  private categoriesToTreeNodes(categories: any[]) {
    this.resourcecategories = [];
    this.parentCategories = [];
    this.parentCategories.push({Id:0, Name: "None (This is a Parent)", Description: ""});
    for (let cont of categories) {
        this.resourcecategories.push(this.categoryToTreeNode(cont));
        this.parentCategories.push(cont);
    }
}

private categoryToTreeNode(cont: any): TreeNode {
    let childcategories: TreeNode[] = [];

    if (cont.ChildCategories !== undefined) {
        for (let c of cont.ChildCategories) {
          childcategories.push(this.childCategoryToTreeNode(c));
        }
    }
   
    return {      
        label: cont.Name,     
        data: cont.Id,    
        children: childcategories,
        type: 'Parent' 
    };
  }

  private  childCategoryToTreeNode(cont:any):TreeNode{
        return {      
          label: cont.Name,           
          data: cont.Id,  
          type: 'Child'
      };
  };

}
